import Endpoint from '../Endpoint'

class Participant extends Endpoint {
  constructor(client, activityId) {
    super(client)
    this.activityId = activityId
  }

  async list() {
    return this.client.request({
      method: 'GET',
      endpoint: `/activities/${this.activityId}/participants`,
    })
  }

  async add(childId) {
    return this.client.request({
      method: 'POST',
      endpoint: `/activities/${this.activityId}/participants`,
      data: { child_id: childId },
    })
  }

  async remove(childId) {
    return this.client.request({
      method: 'DELETE',
      endpoint: `/activities/${this.activityId}/participants/${childId}`,
    })
  }
}

class Membership extends Endpoint {
  constructor(client, activityId) {
    super(client)
    this.activityId = activityId
  }

  async list() {
    return this.client.request({
      method: 'GET',
      endpoint: `/activities/${this.activityId}/memberships`,
    })
  }

  async remove(id) {
    return this.client.request({
      method: 'DELETE',
      endpoint: `/activities/${this.activityId}/memberships/${id}`,
    })
  }
}

class Message extends Endpoint {
  constructor(client, activityId) {
    super(client)
    this.activityId = activityId
  }

  async post(body) {
    return this.client.request({
      method: 'POST',
      endpoint: `/activities/${this.activityId}/messages`,
      data: { body },
    })
  }

  async list() {
    return this.client.request({
      method: 'GET',
      endpoint: `/activities/${this.activityId}/messages`,
    })
  }
}

class Invitation extends Endpoint {
  constructor(client, activityId) {
    super(client)
    this.activityId = activityId
  }

  async invite(email, message) {
    return this.client.request({
      method: 'POST',
      endpoint: `/activities/${this.activityId}/invitations`,
      data: { email, message },
    })
  }

  async list() {
    return this.client.request({
      method: 'GET',
      endpoint: `/activities/${this.activityId}/invitations`,
    })
  }

  async delete(id) {
    return this.client.request({
      method: 'DELETE',
      endpoint: `/activities/${this.activityId}/invitations/${id}`,
    })
  }

  async resend(id) {
    return this.client.request({
      method: 'POST',
      endpoint: `/activities/${this.activityId}/invitations/${id}/resend`,
    })
  }
}

export default class Activity extends Endpoint {
  async create(params) {
    return this.client.request({
      method: 'POST',
      endpoint: '/activities',
      data: params,
    })
  }

  async update(id, params) {
    return this.client.request({
      method: 'PATCH',
      endpoint: `/activities/${id}`,
      data: params,
    })
  }

  async calculatePrice(params) {
    return this.client.request({
      method: 'POST',
      endpoint: '/activities/calculate_price',
      data: params,
    })
  }

  async list() {
    return this.client.request({
      method: 'GET',
      endpoint: '/activities',
    })
  }

  async get(id) {
    return this.client.request({
      method: 'GET',
      endpoint: `/activities/${id}`,
    })
  }

  async pay(id) {
    return this.client.request({
      method: 'POST',
      endpoint: `/activities/${id}/pay`,
    })
  }

  async getReceipt(id) {
    return this.client.request({
      method: 'GET',
      endpoint: `/activities/${id}/receipt`,
    })
  }

  async join(id) {
    return this.client.request({
      method: 'POST',
      endpoint: `/activities/${id}/join`,
    })
  }

  async start(id) {
    return this.client.request({
      method: 'POST',
      endpoint: `/activities/${id}/start`,
    })
  }

  messages(id) {
    return new Message(this.client, id)
  }

  participants(id) {
    return new Participant(this.client, id)
  }

  invitations(id) {
    return new Invitation(this.client, id)
  }

  memberships(id) {
    return new Membership(this.client, id)
  }
}



// WEBPACK FOOTER //
// ../source/api/endpoints/Activity.js